// Canonical legal-document links — single source of truth for the whole app.
//
// Per the B2B legal brief (2026-06-11), the app's legal links must point at the
// canonical ecointel.io pages, NOT Firebase-hosted copies. These are the
// confirmed live pages (verified 2026-06-11). Always use the `www.` host: the
// apex domain (ecointel.io) 301-redirects to www, so linking www directly
// avoids a redirect hop. Change the values here ONLY — every consumer imports
// from this constant so there is a single edit point.
export const LEGAL_LINKS = Object.freeze({
  terms: 'https://www.ecointel.io/terms/',
  privacy: 'https://www.ecointel.io/privacy/',
  dpa: 'https://www.ecointel.io/dpa/',
  cookies: 'https://www.ecointel.io/cookie-policy/',
  disclaimer: 'https://www.ecointel.io/disclaimer/',
  aiUsage: 'https://www.ecointel.io/ai-usage-policy/',
  trust: 'https://www.ecointel.io/trust/',
  connectedServices: 'https://www.ecointel.io/connected-services/',
});

export default LEGAL_LINKS;
